import { FIRST_NAME, LAST_NAME, EMAIL, CREDIT_CARD } from './fieldNames';

const defaults = {
	[FIRST_NAME]: '',
	[LAST_NAME]: '',
	[EMAIL]: '',
	[CREDIT_CARD]: ''
};

export default defaults;